import themeJSON from "../../../src/variants/themes/default.json";

export const shapeConfigs = themeJSON.shapes.shapeConfigs;

export const avatarSizes = themeJSON.shapes.avatarSizes;

export const spaces = themeJSON.shapes.spaces.spacious;
